import React from 'react';
import { useTranslation } from 'react-i18next';
import FriendActions from './FriendActions';

const GridUser = ({ guest, friendRequestCommands, onGuestClick }) => {
  const { t } = useTranslation(['users']);

  const isComplimentary =
    !guest.friendStatus && !guest.firstName && !guest.lastName;

  const onClick = () => {
    onGuestClick(guest);
  };

  return (
    <div>
      <button
        type="button"
        onClick={onClick}
        disabled={isComplimentary}
        className="flex flex-1 flex-col align-center w-full"
      >
        <div className="w-[86px] h-[86px] rounded-full overflow-hidden border-4 border-solid border-primary-200 flex align-center justify-center bg-neutral-100">
          {guest.photoUrl ? (
            <img
              src={guest.photoUrl}
              alt={t('users:profilePic', {
                name: guest.firstName || guest.name
              })}
            />
          ) : (
            <img
              src="/img/icons/account_circle.svg"
              alt={t('users:profilePic', {
                name: guest.firstName || guest.name
              })}
            />
          )}
        </div>
        <div className="w-full overflow-hidden text-base font-bold pt-2 text-center text-ellipsis whitespace-nowrap">
          {guest.firstName || guest.name}
        </div>
      </button>
      {!isComplimentary && (
        <div className="flex pt-1 items-center justify-center">
          <FriendActions
            guest={guest}
            friendRequestCommands={friendRequestCommands}
          />
        </div>
      )}
    </div>
  );
};

export default GridUser;
